import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { AppComponentBase } from '@shared/common/app-component-base';
import { EmployeePunchFailureCount, MarkAttendancesServiceProxy } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'app-punchfailure-view',
  templateUrl: './punchfailure-view.component.html',
  styleUrls: ['./punchfailure-view.component.css']
})
export class PunchfailureViewComponent extends AppComponentBase {

  @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;
    EmployeePunchFailureCount: EmployeePunchFailureCount[] = [];
    constructor(
       injector: Injector,        
       private _markAttendanceAppSeriveProxy:MarkAttendancesServiceProxy,
       
       
   
     ) {
       super(injector);
     }
  
    ngOnInit() {
    }
    show(KraId?: any): void {
      
      debugger;
      this._markAttendanceAppSeriveProxy.getEmployeePunchFailureCounts(KraId).subscribe(result => {
        this.EmployeePunchFailureCount = result;
        
        this.modal.show();
      });
    }
    close(){
      this.modal.hide();
    }
  }
  